import { useCallback, useEffect, useRef, useState } from 'react';

// #91: Auswahl = fluechtige Arbeitsablage (lokaler State, nie URL — Klaerungsprotokoll).
// resetKey traegt den Filter-Fingerabdruck: aendert sich Suche/Filter, leert sich die Auswahl —
// Sammelaktionen duerfen nie unsichtbar markierte Zeilen treffen (Feature-Durchstich).
export function useRowSelection(resetKey: string) {
  const [selected, setSelected] = useState<ReadonlySet<string>>(() => new Set());
  const isFirstRun = useRef(true);

  // biome-ignore lint/correctness/useExhaustiveDependencies: bewusst NUR resetKey — der Effekt IST die Leerung bei Filterwechsel.
  useEffect(() => {
    // Leerung gilt dem WECHSEL, nicht dem Mount; Konsumenten (Tasks 13/14) haengen `selected`
    // ggf. in Deps — ein Clear direkt nach Mount waere ein unnoetiger Re-Render + Identitaetswechsel.
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    setSelected(new Set());
  }, [resetKey]);

  const toggle = useCallback((id: string) => {
    setSelected((prev) => {
      const next = new Set(prev);
      // Ternaerer Ausdruck als Statement waere hier ein Nebeneffekt-Ausdruck ohne Wert —
      // ausformuliert statt `next.has(id) ? next.delete(id) : next.add(id)` (Biome-konform,
      // funktional identisch).
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);
  const setMany = useCallback((ids: string[], on: boolean) => {
    setSelected((prev) => {
      const next = new Set(prev);
      for (const id of ids) {
        if (on) {
          next.add(id);
        } else {
          next.delete(id);
        }
      }
      return next;
    });
  }, []);
  const clear = useCallback(() => setSelected(new Set()), []);
  const isSelected = useCallback((id: string) => selected.has(id), [selected]);

  return { selected, isSelected, toggle, setMany, clear };
}
